import React, { useState, useContext } from 'react';
import { TaskContext } from './TaskContext';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import './Sidebar.css'
import { Timestamp } from "firebase/firestore";

const Sidebar = ({ setFilterGroupIds }) => {
  const { addGroup, groups, addEvent, deleteGroup, addGroupError, setAddGroupError } = useContext(TaskContext);
  const [groupName, setGroupName] = useState('');
  const [groupColor, setGroupColor] = useState('#FFFFFF');
  const [eventTitle, setEventTitle] = useState('');
  const [eventStartTime, setEventStartTime] = useState(new Date());
  const [eventEndTime, setEventEndTime] = useState(new Date());
  const [selectedGroup, setSelectedGroup] = useState('');


  const handleGroupFilterChange = (groupId, isChecked) => {
    setFilterGroupIds(currentFilters =>
      isChecked ? [...currentFilters, groupId] : currentFilters.filter(id => id !== groupId)
    );
  };


  const handleGroupSubmit = (e) => {
    e.preventDefault();
    setAddGroupError('');
    addGroup(groupName, groupColor);
    setGroupName('');
    setGroupColor('#FFFFFF');
  };

  const handleEventSubmit = (e) => {
    e.preventDefault();
    if (!selectedGroup) {
      alert('Please select a group for the event.');
      return;
    }
    const startTimestamp = Timestamp.fromDate(eventStartTime);
    const endTimestamp = Timestamp.fromDate(eventEndTime);

    const eventData = {
      title: eventTitle,
      start: eventStartTime,
      end: eventEndTime,
      groupId: selectedGroup,
      color: groups.find(group => group.id === selectedGroup)?.color
    };
    addEvent(eventData);
    setEventTitle('');
    setEventStartTime(new Date());
    setEventEndTime(new Date());
    setSelectedGroup('');
  };

  return (
    <div className="sidebar-container">
      <h3>Create Group</h3>
      {addGroupError && <p className="error-message">{addGroupError}</p>} {/* Display any add group error */}
      <form onSubmit={handleGroupSubmit} className="sidebar-section">
        <input type="text" value={groupName} onChange={(e) => setGroupName(e.target.value)} placeholder="Group Name" required />
        <input type="color" value={groupColor} onChange={(e) => setGroupColor(e.target.value)} />
        <button type="submit">Add Group</button>
      </form>

      <div className="sidebar-section">
        <h3>Groups</h3>
        <ul>
          {groups.map(group => (
            <li key={group.id} className="group-item">
              <span className="group-name">{group.name}</span>
              <span className="color-swatch" style={{ backgroundColor: group.color }}></span>
              <button onClick={() => deleteGroup(group.id)}>Delete</button>
            </li>
          ))}
        </ul>
      </div>

      <div className="sidebar-section">
        <h3>Filter by Groups</h3>
        {groups.map(group => (
          <div key={group.id} className="group-filter-item">
            <input
              type="checkbox"
              id={`filter-${group.id}`}
              onChange={e => handleGroupFilterChange(group.id, e.target.checked)}
            />
            <label htmlFor={`filter-${group.id}`}>{group.name}</label>
          </div>
        ))}
      </div>

      <form onSubmit={handleEventSubmit} className="sidebar-section">
      <h3>Create Event</h3>
        <input type="text" value={eventTitle} onChange={(e) => setEventTitle(e.target.value)} placeholder="Event Title" required />

        {/* Start Time Picker Section */}
        <div className="datetime-picker-container">
          <label htmlFor="start-time">Start Time:</label>
          <DatePicker
            id="start-time"
            selected={eventStartTime}
            onChange={date => setEventStartTime(date)}
            showTimeSelect
            timeIntervals={30}
            timeFormat="hh:mm aa"
            dateFormat="MMMM d, yyyy h:mm aa"
            timeCaption="Time"
            className="date-picker"
          />
        </div>

        {/* End Time Picker Section */}
        <div className="datetime-picker-container">
          <label htmlFor="end-time">End Time:</label>
          <DatePicker
            id="end-time"
            selected={eventEndTime}
            onChange={date => setEventEndTime(date)}
            showTimeSelect
            timeIntervals={30}
            timeFormat="hh:mm aa"
            dateFormat="MMMM d, yyyy h:mm aa"
            timeCaption="Time"
            className="date-picker"
          />
        </div>

        <select value={selectedGroup} onChange={(e) => setSelectedGroup(e.target.value)} required>
          <option value="">Select Group</option>
          {groups.map(group => (
            <option key={group.id} value={group.id}>{group.name}</option>
          ))}
        </select>

        <button type="submit">Add Event</button>
      </form>
    </div>
  );
};

export default Sidebar;
